var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeInactive = function SvgEyeInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    fillRule: "evenodd",
    d: "M3.138 11.993C4.163 10.248 5.56 8.8 7.207 7.828L8.68 9.302c-1 .503-1.916 1.23-2.703 2.142a1.61 1.61 0 0 0 0 2.112C7.578 15.41 9.709 16.5 12 16.5c1.103 0 2.17-.253 3.157-.722l1.483 1.483A9.36 9.36 0 0 1 12 18.5c-3.728 0-6.944-2.229-8.862-5.493a1 1 0 0 1 0-1.014M12 16.5a4 4 0 0 1-2.888-6.767l1.415 1.415a2 2 0 0 0 2.826 2.826l1.414 1.414A3.99 3.99 0 0 1 12 16.5m.124-7.997v-.001m6.907 6.907-1.413-1.414q.207-.212.404-.44a1.61 1.61 0 0 0 0-2.112c-1.571-1.82-3.655-2.905-5.9-2.943l-1.84-1.84A9.2 9.2 0 0 1 12 6.5c3.728 0 6.944 2.229 8.862 5.493a1 1 0 0 1 0 1.014 12.4 12.4 0 0 1-1.83 2.403",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 24,
    x: 3,
    y: 4.207,
    fill: "#B2C9DE",
    rx: 0.75,
    transform: "rotate(-45 3 4.207)"
  })));
};
export default SvgEyeInactive;